import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

import { Role } from 'src/types';
import { KEYS } from '../keys';
import {
  MOCK_USER_TOKEN, MOCK_USER_NAME,
  MOCK_USER_IMG, MOCK_USER_ROLE
} from '../../models/buildtime-constant';

const { persistAtom } = recoilPersist();

export type AuthState = {
  token: string;
  name: string;
  pictureBase64: string;
  role: Role;
};

const authState = atom<Partial<AuthState>>({
  key: KEYS.AUTH,
  default: {
    token: MOCK_USER_TOKEN,
    name: MOCK_USER_NAME,
    pictureBase64: MOCK_USER_IMG,
    role: MOCK_USER_ROLE as Role,
  },
  effects_UNSTABLE: [persistAtom],
});

export default authState;
